import { type Promotion } from '@/features/shop/services/Campaigns/types'
import {
  getFeaturedPromoCardProperties,
  trackPromoCardClicked,
  trackPromoCardViewed,
} from '@/features/shared/analytics/promoCard'
import { ScrollIntoView } from '@/features/shared/components/ScrollIntoView'
import { trackElementViewed } from '@/features/shared/analytics/element'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { formatPromotionExpiration } from '@/features/shared/utils/promotionUtils'
import { DynamicPromotionTermsModal } from '@/features/shop/components/Modal/PromotionTermsModal/DynamicPromotionTermsModal'

import { Column } from '@shipt/design-system-layouts'
import { PromoBanner } from '@shipt/design-system-banner'

type Props = {
  promotionToShow: Promotion | undefined
}
export const ShowHeroPromoBanner = ({ promotionToShow }: Props) => {
  const { openDialog } = useHandleDialog()

  const { display_name, display_description } = promotionToShow ?? {}

  if (!promotionToShow || !display_description || !display_name) return null

  const featuredPromoCardProperties = getFeaturedPromoCardProperties({
    promotion: promotionToShow,
  })

  const openTermsModal = () => {
    openDialog(DynamicPromotionTermsModal, {
      promotion: promotionToShow,
    })
    trackElementViewed({
      type: 'modal',
      message_goal: 'promotion_terms',
      content: display_name,
      display_sublocation: 'marketing_promotion',
    })
    trackPromoCardClicked(featuredPromoCardProperties)
  }

  return (
    <ScrollIntoView
      onInView={() => {
        trackPromoCardViewed(featuredPromoCardProperties)
      }}
    >
      <Column marginTop="md" marginBottom="md">
        <PromoBanner
          title={display_description}
          variant="brand"
          actionButton={{
            variant: 'ghost',
            onClick: openTermsModal,
            content: 'View terms',
          }}
          description={formatPromotionExpiration(promotionToShow)}
        />
      </Column>
    </ScrollIntoView>
  )
}
